import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="London">
                <h1>iOS App Development Company in UK</h1>
              </div>
              <p className="main_para">
                TekRevol takes pride in being recognized as a bespoke iOS app
                development company in London. Our dedicated team of
                professionals transforms your app ideas into reality using the
                latest technologies and industry best practices. Our approach
                goes beyond mere development – we strive to create solutions
                that not only meet but exceed your expectations. As your trusted
                iPhone app development team in London, we understand the
                importance of staying ahead in the dynamic tech market.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
